
import React from 'react';
import { Book } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import LearningPath from './LearningPath';
import EnrolledCoursesList from './EnrolledCoursesList';
import AchievementsList from './AchievementsList';
import { Course, EnrolledCourse } from '@/types';

interface MyLearningTabContentProps {
  courses: Course[];
  enrolledCourses: EnrolledCourse[];
  achievements: {
    id: string;
    title: string;
    completedDate: Date;
  }[];
  onContinueCourse: (courseId: string, moduleId: string) => void;
  onEnrollCourse: (courseId: string) => void;
}

const MyLearningTabContent: React.FC<MyLearningTabContentProps> = ({
  courses,
  enrolledCourses,
  achievements,
  onContinueCourse,
  onEnrollCourse
}) => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Book className="h-5 w-5 text-primary" />
            Current Learning Path
          </CardTitle>
          <CardDescription>
            Continue where you left off
          </CardDescription>
        </CardHeader>
        <CardContent>
          <LearningPath 
            pathTitle="Artist Career Development"
            pathDescription="Master the essentials of building a successful music career"
            courses={courses}
            enrolledCourses={enrolledCourses}
            onContinue={onContinueCourse}
            onEnroll={onEnrollCourse}
          />
        </CardContent>
      </Card>
      
      <div className="grid md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Enrolled Courses</CardTitle>
            <CardDescription>Courses you're currently taking</CardDescription>
          </CardHeader>
          <CardContent>
            <EnrolledCoursesList 
              enrolledCourses={enrolledCourses}
              courses={courses}
              onContinue={onContinueCourse}
            />
          </CardContent>
        </Card>
        
        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Achievements</CardTitle>
            <CardDescription>Your learning achievements</CardDescription>
          </CardHeader>
          <CardContent>
            <AchievementsList achievements={achievements} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default MyLearningTabContent;
